// Konfiguration för loggning
export const LoggingConfig = {
  // Sätt till false för att inaktivera alla konsolloggar
  enabled: true,
  
  // Loggningsnivå: 'debug', 'info', 'warn', 'error', 'none'
  level: 'warn',
  
  // Tidsintervall mellan loggmeddelanden i millisekunder
  throttleInterval: 60000, // 60 sekunder
  
  // Specifika inställningar för komponenter
  components: {
    InteractiveMap: {
      enabled: true,
      level: 'warn', // Endast varningar och fel
      logRender: false // Inaktivera render-loggar
    },
    SwedishTimeCounter: {
      enabled: true,
      level: 'warn'
    }
  }
};

// Hjälpfunktioner för loggning
const logTimes = {};

// Hjälpfunktion för att kontrollera om en loggning ska visas
const shouldLog = (component, type) => {
  if (!LoggingConfig.enabled) return false;
  
  const config = LoggingConfig.components[component] || {};
  if (config.enabled === false) return false;
  
  // Kontrollera loggningsnivå
  const levels = {
    debug: ['debug', 'info', 'warn', 'error'],
    info: ['info', 'warn', 'error'],
    warn: ['warn', 'error'],
    error: ['error']
  };
  
  const componentLevel = config.level || LoggingConfig.level;
  if (!levels[type].includes(componentLevel)) return false;
  
  // Kontrollera tidsintervall
  const now = Date.now();
  const lastTime = logTimes[component]?.[type] || 0;
  const interval = config.throttleInterval || LoggingConfig.throttleInterval;
  
  if (now - lastTime < interval) return false;
  
  // Uppdatera sista loggtiden
  if (!logTimes[component]) logTimes[component] = {};
  logTimes[component][type] = now;
  return true;
};

export const logger = {
  debug: (component, ...args) => {
    if (shouldLog(component, 'debug')) {
      console.debug(`[${component}]`, ...args);
    }
  },
  
  info: (component, ...args) => {
    if (shouldLog(component, 'info')) {
      console.info(`[${component}]`, ...args);
    }
  },
  
  warn: (component, ...args) => {
    if (shouldLog(component, 'warn')) {
      console.warn(`[${component}] ⚠️`, ...args);
    }
  },
  
  error: (component, ...args) => {
    if (shouldLog(component, 'error')) {
      console.error(`[${component}] ❌`, ...args);
    }
  }
};
